import { useEffect, useRef, useState } from 'react';
import { classNames } from '~/utils';
import { Icon } from '../icon';

type CollapsibleTextProps = {
  text: string;
  lineHeight?: number;
  className?: string;
};

export const CollapsibleText = ({ text, className, lineHeight = 24 }: CollapsibleTextProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);

  // `text` isn't read here, but new text changes the paragraph's height, so it must re-measure
  useEffect(() => {
    if (textRef.current) {
      setShowButton(textRef.current.scrollHeight > lineHeight);
    }
  }, [text, lineHeight]);

  return (
    <div className="flex items-start">
      <p
        className={classNames('body-100-light', className, { 'line-clamp-1': !isExpanded })}
        ref={textRef}
        style={{ lineHeight: `${lineHeight}px` }}
      >
        {text}
      </p>

      {showButton && (
        <button className="ml-4" onClick={() => setIsExpanded(!isExpanded)} type="button">
          <Icon icon={isExpanded ? 'ArrowDropUpLineIcon' : 'ArrowDropDownLineIcon'} />
        </button>
      )}
    </div>
  );
};

export default CollapsibleText;
